import { SILA_DOCS_URL, SUPERUSER_LEVEL, EMAIL_SUPPORT_URL, PRE_QUALIFIED_LINK } from '.';
import { hasPermissions, hasSuperuserAccess, hasSalesAccess } from '../utils';

export const primaryNav = [
  {
    name: 'home',
    title: 'sidebar.navigation.home',
    to: '/welcome',
    iconClass: 'sila-icon home',
  },
  {
    name: 'apps',
    title: 'sidebar.navigation.applications',
    iconClass: 'sila-icon apps',
    to: '/apps',
  },
  {
    name: 'settings',
    title: 'sidebar.navigation.settings',
    iconClass: 'sila-icon settings',
    to: '/settings',
  },
  {
    name: 'developers',
    title: 'sidebar.navigation.developer',
    iconClass: 'sila-icon developers',
    to: '/dev',
    permissions: (user) => hasPermissions(user, 'webhooks', 'Read'),
  },
  {
    name: 'sales',
    title: 'sidebar.navigation.sales',
    iconClass: 'sila-icon business',
    to: '/sales',
    permissions: (user) => hasSalesAccess(user),
  },
  {
    name: 'admin',
    title: 'sidebar.navigation.admin',
    iconClass: 'sila-icon individual',
    to: '/admin',
    permissions: (user) => hasSuperuserAccess(user, [SUPERUSER_LEVEL.FULL_ACCESS]),
  },
];

export const secondaryNav = [
  {
    name: 'onboarding',
    title: 'sidebar.navigation.onboarding',
    iconClass: 'sila-icon check',
    href: PRE_QUALIFIED_LINK,
    permissions: (user) => !user.approved,
  },
  {
    name: 'support',
    title: 'sidebar.navigation.support',
    iconClass: 'sila-icon support',
    href: EMAIL_SUPPORT_URL,
  },
  {
    name: 'docs',
    title: 'sidebar.navigation.documentation',
    iconClass: 'sila-icon docs',
    href: SILA_DOCS_URL,
    newWindow: true,
  },
];
